import { computed } from 'vue'

import { ChatBotMessageInputTypes } from '@shared/models/enums/messages'
import DeviceInfo from '@shared/plugins/device-info'

import { useMessagesStore } from '@pc/store/messages'
import { useSessionStore } from '@pc/store/session'

export const useAttachmentSelect = () => {
  const sessionStore = useSessionStore()
  const messagesStore = useMessagesStore()

  const widget = computed(() => sessionStore.chatProps?.chatWidget)
  const messages = computed(() => messagesStore.messages.data)
  const lastMessageInputType = computed(() => {
    const messagesLength = messages.value?.data?.length ?? 0
    const lastMessage = (messages.value?.data ?? [])[messagesLength - 1] ?? null
    const shouldBeParsed = lastMessage?.text?.includes('{"')

    return shouldBeParsed ? JSON.parse(lastMessage.text ?? '')?.input_type : ''
  })

  const isTextOnly = computed(() => {
    const textOnlyInputTypes = [
      ChatBotMessageInputTypes.FirstName,
      ChatBotMessageInputTypes.LastName,
      ChatBotMessageInputTypes.Email,
      ChatBotMessageInputTypes.Name,
      ChatBotMessageInputTypes.Phone,
      ChatBotMessageInputTypes.TimeDay,
    ]

    return textOnlyInputTypes.includes(lastMessageInputType.value)
  })

  const isAbleToSendAttachments = computed(() => {
    if (widget.value?.disableChatAttachments) {
      return false
    }
    return !isTextOnly.value
  })

  const showEmojis = computed(() => !widget.value?.disableChatEmojis)
  const showEmojisPicker = computed(
    () => showEmojis.value && !DeviceInfo.isMobile
  )

  return {
    isAbleToSendAttachments,
    showEmojis,
    showEmojisPicker,
    isTextOnly,
  }
}
